const styles = {
  backdropDialog: {
    backdropFilter: 'blur(5px)'
  },
  actionButton: {
    textTransform: 'none'
  }
};

export default styles;
